module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    class: {
      toggled: _vm.$sidebar.showSidebar
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar1"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar2"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar3"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand"
  }, [_vm._v(_vm._s(_vm.routeName))])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-right-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('div', {
    staticClass: "selectBoxMargin"
  }, [_c('span', {
    staticClass: "licName"
  }, [_vm._v(_vm._s(_vm.licName))]), _vm._v(" "), (_vm.checkLicensesLength()) ? _c('label', {
    staticClass: "licLabel"
  }, [_vm._v("Wybierz licencje")]) : _vm._e(), _vm._v(" "), _c('el-select', {
    attrs: {
      "disabled": !_vm.checkLicensesLength(),
      "placeholder": "Licencja",
      "change": _vm.changeLicense(_vm.license)
    },
    model: {
      value: (_vm.license),
      callback: function($$v) {
        _vm.license = $$v
      },
      expression: "license"
    }
  }, _vm._l((_vm.licenses), function(item) {
    return _c('el-option', {
      key: item.lic,
      attrs: {
        "value": item.lic
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn-rotate",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.onLogout
    }
  }, [_c('i', {
    staticClass: "ti-close"
  }), _vm._v(" "), _c('p', [_vm._v("\n                            Logout\n                        ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6cba2f67!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Layout/TopNavbar.vue
// module id = 445
// module chunks = 1